import { render } from "./UuId.vue?vue&type=template&id=cf8598bc&scoped=true"
import script from "./UuId.vue?vue&type=script&lang=js"
export * from "./UuId.vue?vue&type=script&lang=js"

import "./UuId.vue?vue&type=style&index=0&id=cf8598bc&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8598bc"]])

export default __exports__